var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.selectedIcon,{tag:"component",staticClass:"Icon",class:{ 'Icon--desktop': _vm.desktop }})}
var staticRenderFns = []

export { render, staticRenderFns }